/** @flow */
const images = ['jpg', 'jpeg', 'png', 'gif', 'tif', 'tiff', 'bmp'];
const tables = ['csv', 'xls', 'xlsx'];
const documents = ['pdf', 'doc', 'docx', 'rtf', 'txt', 'odt'];

export const imageFormatList = images.map((format) => `.${format}`).join(',');
export const tableFormatList = tables.map((format) => `.${format}`).join(',');
export const documentFormatList = documents.map((format) => `.${format}`).join(',');

export const hasFileFormat = (fileName, formats) => {
  const match = /\.([^./\\]+)$/.exec(fileName || '');
  return Boolean(match) && formats.includes(match[1].toLowerCase());
};

export default {
  images,
  tables,
  documents,
};
